<script>
import ModalDiscountComponent from '../../features/modals/ModalDiscountComponent';
export default {
  name: 'ModalDiscountView',
  extends: ModalDiscountComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Descuento"
    width="30%"
    class="discount-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <fieldset>
        <legend>Información de Descuento</legend>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col :span="24">
            <el-form-item
              label="Plan de Inscripción"
              prop="subscriptionPlan"
            >
              <el-select
                v-model="formData.subscriptionPlan"
                remote
                clearable
                filterable
                placeholder="Buscar..."
                :remote-method="onSearchSubscriptionPlans"
                value-key="id"
                size="small"
              >
                <el-option
                  v-for="item in (subscriptionPlans || []).filter(Boolean)"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col>
            <el-form-item
              label="Código"
              prop="code"
            >
              <el-input
                v-model="formData.code"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col>
            <el-form-item
              label="Nombre"
              prop="name"
            >
              <el-input
                v-model="formData.name"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col text-align="center">
            <el-form-item
              label="Disponibilidad"
              prop="reportDate"
            >
              <el-date-picker
                v-model="formData.reportDate"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="-"
                start-placeholder="F. Inicio"
                end-placeholder="F. Fin"
                value-format="YYYY-MM-DD"
                format="DD MMM YYYY"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          class="row-bg"
          :gutter="20"
        >
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            text-align="center"
          >
            <el-form-item
              label="Cantidad (%)"
              prop="amount"
            >
              <el-input-number
                v-model="formData.amount"
                :min="0"
                :max="100"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="12"
            :xl="12"
            text-align="center"
          >
            <el-form-item
              label="Capacidad de Usuarios"
              prop="max"
            >
              <el-input-number
                v-model="formData.max"
                :min="0"
                size="small"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </fieldset>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>